import { useStaticQuery, graphql } from 'gatsby';
import { useLocation } from '@gatsbyjs/reach-router';

export const useHrefLang = () => {
  const location = useLocation();
  const { site } = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          siteUrl
        }
      }
    }
  `);

  const siteUrl = site.siteMetadata.siteUrl;
  const pathWithoutSlash = location.pathname.replace(/\/$/, '');

  return [
    {
      rel: 'alternate',
      hreflang: 'x-default',
      href: `${siteUrl}${pathWithoutSlash}`,
    },
    {
      rel: 'alternate',
      hreflang: 'en',
      href: `${siteUrl}${pathWithoutSlash}`,
    },
    {
      rel: 'alternate',
      hreflang: 'de-DE',
      href: `${siteUrl}/de${pathWithoutSlash}`,
    },
  ];
};
